"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMediaCampaignDto = exports.MediaInCampaignDisplaySettingsDto = void 0;
const class_transformer_1 = require("class-transformer");
const campaign_media_adaptations_dto_1 = require("./campaign-media-adaptations.dto");
const campaign_creative_rotation_dto_1 = require("./campaign-creative-rotation.dto");
const class_validator_1 = require("class-validator");
let ExclusiveCampaignCreativeModels = class ExclusiveCampaignCreativeModels {
    validate(_value, args) {
        return args.object.mediaAdaptations === undefined;
    }
    defaultMessage() {
        return "mediaAdaptations and creativeRotation cannot be supplied together";
    }
};
ExclusiveCampaignCreativeModels = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "exclusiveCampaignCreativeModels", async: false })
], ExclusiveCampaignCreativeModels);
class MediaInCampaignDisplaySettingsDto {
    displayId;
    objectFit;
}
exports.MediaInCampaignDisplaySettingsDto = MediaInCampaignDisplaySettingsDto;
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], MediaInCampaignDisplaySettingsDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(["contain", "cover", "fill", "scale-down", "none"], {
        message: 'El valor de objectFit debe ser "contain", "cover", "fill", "scale-down" o "none"',
    }),
    (0, class_validator_1.ValidateIf)((o) => !!o.objectFit),
    __metadata("design:type", String)
], MediaInCampaignDisplaySettingsDto.prototype, "objectFit", void 0);
class CreateMediaCampaignDto {
    creativeRotation;
    mediaAdaptations;
    summaryId;
    name;
    title;
    qr;
    settings;
    metadata;
    skipPayment;
    creationId;
}
exports.CreateMediaCampaignDto = CreateMediaCampaignDto;
__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.creativeRotation !== undefined),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => campaign_creative_rotation_dto_1.CampaignCreativeRotationDto),
    (0, class_validator_1.Validate)(ExclusiveCampaignCreativeModels),
    __metadata("design:type", campaign_creative_rotation_dto_1.CampaignCreativeRotationDto)
], CreateMediaCampaignDto.prototype, "creativeRotation", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.mediaAdaptations !== undefined),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => campaign_media_adaptations_dto_1.CampaignMediaAdaptationsDto),
    __metadata("design:type", campaign_media_adaptations_dto_1.CampaignMediaAdaptationsDto)
], CreateMediaCampaignDto.prototype, "mediaAdaptations", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CreateMediaCampaignDto.prototype, "summaryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateMediaCampaignDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateMediaCampaignDto.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsUrl)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => !!o.qr),
    __metadata("design:type", String)
], CreateMediaCampaignDto.prototype, "qr", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => !!o.settings && o.settings.length > 0),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => MediaInCampaignDisplaySettingsDto),
    __metadata("design:type", Array)
], CreateMediaCampaignDto.prototype, "settings", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => !!o.metadata),
    __metadata("design:type", Object)
], CreateMediaCampaignDto.prototype, "metadata", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], CreateMediaCampaignDto.prototype, "skipPayment", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CreateMediaCampaignDto.prototype, "creationId", void 0);
